import { render, staticRenderFns } from "./BookingCustomerDetails.vue?vue&type=template&id=66ed84b4&scoped=true"
import script from "./BookingCustomerDetails.vue?vue&type=script&lang=js"
export * from "./BookingCustomerDetails.vue?vue&type=script&lang=js"
import style0 from "./BookingCustomerDetails.vue?vue&type=style&index=0&id=66ed84b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ed84b4",
  null
  
)

export default component.exports